<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.4999 19.6073C10.2443 19.6073 10.0007 19.5594 9.76914 19.4635C9.53754 19.3677 9.32591 19.2319 9.13424 19.0562L1.44362 11.3656C1.26793 11.174 1.13216 10.9623 1.03633 10.7307C0.940495 10.4991 0.892578 10.2555 0.892578 9.99999C0.892578 9.74444 0.940495 9.49687 1.03633 9.25728C1.13216 9.0177 1.26793 8.81006 1.44362 8.63437L9.13424 0.943742C9.32591 0.752075 9.53754 0.612318 9.76914 0.524471C10.0007 0.436624 10.2443 0.3927 10.4999 0.3927C10.7554 0.3927 11.003 0.436624 11.2426 0.524471C11.4822 0.612318 11.6898 0.752075 11.8655 0.943742L19.5561 8.63437C19.7478 8.81006 19.8875 9.0177 19.9754 9.25728C20.0632 9.49687 20.1072 9.74444 20.1072 9.99999C20.1072 10.2555 20.0632 10.4991 19.9754 10.7307C19.8875 10.9623 19.7478 11.174 19.5561 11.3656L11.8655 19.0562C11.6898 19.2319 11.4822 19.3677 11.2426 19.4635C11.003 19.5594 10.7554 19.6073 10.4999 19.6073ZM9.54154 10.9583H11.4582V5.20833H9.54154V10.9583ZM10.4999 13.8333C10.7714 13.8333 10.999 13.7415 11.1827 13.5578C11.3664 13.3741 11.4582 13.1465 11.4582 12.875C11.4582 12.6035 11.3664 12.3759 11.1827 12.1922C10.999 12.0085 10.7714 11.9167 10.4999 11.9167C10.2283 11.9167 10.0007 12.0085 9.81706 12.1922C9.63338 12.3759 9.54154 12.6035 9.54154 12.875C9.54154 13.1465 9.63338 13.3741 9.81706 13.5578C10.0007 13.7415 10.2283 13.8333 10.4999 13.8333Z"
      :fill="fill"
    />
  </svg>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    width?: string;
    height?: string;
    fill?: string;
  }>(),
  {
    width: "20",
    height: "20",
    fill: "#C9372C",
  }
);
</script>

<style scoped></style>
